export const getPages = state => state.global.pages;

export function getPageByName(state, name) {
    return getPages(state)[name];
}



/** WEBPACK FOOTER **
 ** ./src/core/global/globalSelectors.js
 **/